import { PlanCreditsSummary } from '@/components/plan-credits-summary'
import type { usePlanAndCredits } from '@/hooks/use-plan-and-credits'
import type { Subscription } from '@/types'

export default function BillingOverview({
  state,
  subscriptions,
}: {
  state: ReturnType<typeof usePlanAndCredits>
  subscriptions: Subscription[]
}) {
  const { currentPlan, creditsData, loading } = state
  const subscription = subscriptions[0] || null

  if (!currentPlan && creditsData.remaining <= 0) {
    return loading ? null : (
      <div className="rounded-[1.75rem] border border-stone-200/80 bg-white/80 p-8 text-center shadow-sm">
        <h3 className="text-lg font-semibold text-stone-950">Ready to get started?</h3>
        <p className="mt-2 text-sm text-stone-500">Choose a plan below to start using PlusE Finance APIs.</p>
      </div>
    )
  }

  return (
    <PlanCreditsSummary
      currentPlan={currentPlan}
      creditsData={creditsData}
      subscription={subscription}
    />
  )
}
